export enum MediaType {
  Audio = 10,
  EventPlaylist = 32,
  LoopPlaylist = 13,
  Folder = 35,
  Ad = 49,
}
